import { getReq } from '../service/API'
import useSWR from 'swr'
import { ENDPOINTS } from '../config/endpoints'

export const useParticipants = (projectId: string) => {
  const endpoint = ENDPOINTS.ADMIN.PARTICIPANTS.get(projectId)
  const { data, error, mutate } = useSWR(endpoint, getReq, { suspense: true })

  return {
    data: !data ? data : data.data,
    isLoading: !error && !data,
    isError: error,
    mutate: mutate,
  }
}
